var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"z-app",attrs:{"id":"dashboard-view","dark":""}},[_c('core-toolbar'),_c('core-drawer'),_c('v-main',{staticClass:"z-main"},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),(_vm.$route.meta.name !== 'Maps')?_c('core-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }